import { useEffect, useState } from 'react';
import { fetchSolanaBlock } from '../api/transactions';

export function useSolanaBlock(slot) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(slot || '').trim();
    if (!/^[0-9]+$/.test(normalized)) {
      setLoading(false);
      setError('Invalid block slot.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchSolanaBlock(normalized)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Block not found.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [slot]);

  return { data, loading, error };
}
